<template>
  <div class="featured-podcast pointer has-edit-button">
    <ion-card class="m-y-4">
      <EditButton
        v-if="canEdit"
        :url="`companies/${courseData.company_id}/courses/${courseData.id}/edit`"
      />
      <AppImg
        :img-src="imageUrl"
        img-alt="featured podcast image"
        border-radius="10px"
        class="img-wrap"
      />
    </ion-card>
  </div>
</template>

<script>
import AppImg from '@/components/common/AppImg.vue';
import EditButton from '@/components/common/EditButton.vue';
import { getSmallestSizeImage } from '@/helpers/functions';
import { computed } from '@vue/reactivity';
import { useStore } from 'vuex';

import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonImg,
} from '@ionic/vue';

export default {
  name: 'RegularCourseCard',
  components: {
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardSubtitle,
    IonImg,
    AppImg,
    EditButton,
  },
  props: {
    courseData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    const imageUrl = computed(() => {
      const images = props.courseData?.media.slice() ?? [];
      images.sort((a, b) => b.category - a.category);
      return getSmallestSizeImage(props.courseData?.media)?.url ?? null;
    });

    const canEdit = computed(() => {
      const hasPermission =
        store.getters['authentication/hasPermission']('update_course');
      const isWeb = store.state.app.platform === 'web';
      return hasPermission && isWeb;
    });

    return { imageUrl, canEdit };
  },
};
</script>

<style scoped lang="scss">
@use '@/theme/custom' as *;

.featured-podcast {
  width: 210px;
}

.img-wrap {
  width: 200px;
  height: 200px;

  :deep(img) {
    width: 100%;
    height: 100%;
  }
}

.featured-podcast ion-card {
  margin: 10px 10px 24px 0px;
}

@media (max-width: $tablet-breakpoint) {
  .featured-podcast {
    width: 176px;
  }
  .img-wrap {
    width: 150px;
    height: 150px;
  }
}
</style>
